import { render, staticRenderFns } from "./WinnersModal.vue?vue&type=template&id=70253e04&scoped=true&"
import script from "./WinnersModal.vue?vue&type=script&lang=js&"
export * from "./WinnersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70253e04",
  null
  
)

export default component.exports